const getLinkSectionTypes = ['waiver-v3', 'release-of-liability-v3'];

export const isGetLinkType = documentType => (
  getLinkSectionTypes.indexOf(documentType) !== -1
);

export const isLastSectionGetLink = (documentType, fieldValue) => {
  const isGeneralForm = fieldValue === 'general_form';
  return isGeneralForm && isGetLinkType(documentType);
};

export const stepsToTime = (numberOfSteps) => {
  const TIME_TO_COMPLETE_SECTION_MULTIPLIER = 1 / 3;
  const time = numberOfSteps * TIME_TO_COMPLETE_SECTION_MULTIPLIER;
  const minutes = Math.floor(time);
  let seconds = (time * 60) % 60;
  seconds = seconds.toFixed(0);
  let timeString = '';

  if (minutes <= 0 && seconds > 0) {
    return `${seconds} sec`;
  }

  if (minutes > 0) {
    timeString = `${minutes} min`;
  }
  if (minutes > 1) {
    timeString = `${timeString}s`;
  }
  if (seconds > 0) {
    timeString = `${timeString} ${seconds} sec`;
  }
  return timeString;
};



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/Utils/index.jsx